import { Button } from "@/components/ui/button";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MAILVISTA_DOMAIN_URLS } from "@/domain/entities/MailvistaUrl";
import MailvistaUrls from "@/domain/enums/MailvistaUrls";
import { isB2CUserType } from "@/domain/enums/UserType";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { setSettingsDialogOpen } from "@/stores/settingsStore";
import { useTranslation } from "react-i18next";

const LegalPagesSettings = () => {
    const { t } = useTranslation();
    const { data: user } = useGetUserProfile();

    return (
        <div className="flex flex-col gap-8">
            <DialogHeader>
                <DialogTitle className="font-bold leading-none">
                    {t("settings.legalPages.title")}
                </DialogTitle>
                <p className="text-xs">
                    {t("settings.legalPages.description")}
                </p>
            </DialogHeader>
            <div className="flex w-full flex-col items-center gap-8 py-12 font-body text-sm font-medium text-text-active">
                <p className="mx-auto max-w-[350px] text-center font-body text-sm font-normal text-text-active">
                    {t("settings.legalPages.personalDataRequestBefore")}
                    <a
                        className="underline"
                        href={
                            MAILVISTA_DOMAIN_URLS[
                                isB2CUserType(user?.userType)
                                    ? MailvistaUrls.CONDITIONGENERALESUTILISATIONPARTICULIER
                                    : MailvistaUrls.CONDITIONGENERALESUTILISATIONENTREPRISE
                            ].url
                        }
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t("settings.legalPages.personalDataRequestLink")}
                    </a>
                    {t("settings.legalPages.personalDataRequestAfter")}
                </p>
                <div className="flex flex-col items-center gap-2">
                    <a
                        className="underline"
                        href={
                            MAILVISTA_DOMAIN_URLS[
                                MailvistaUrls.MENTIONLEGALEAPPLICATION
                            ].url
                        }
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t("legalPages.legalMentions")}
                    </a>
                    <p className="flex gap-1">
                        {isB2CUserType(user?.userType) ? (
                            <a
                                className="underline"
                                href={
                                    MAILVISTA_DOMAIN_URLS[
                                        MailvistaUrls
                                            .CONDITIONGENERALESUTILISATIONPARTICULIER
                                    ].url
                                }
                                rel="noreferrer"
                                target="_blank"
                            >
                                {t("legalPages.cgu")} {t("legalPages.b2c")}
                            </a>
                        ) : (
                            <a
                                className="underline"
                                href={
                                    MAILVISTA_DOMAIN_URLS[
                                        MailvistaUrls
                                            .CONDITIONGENERALESUTILISATIONENTREPRISE
                                    ].url
                                }
                                rel="noreferrer"
                                target="_blank"
                            >
                                {t("legalPages.cgu")} {t("legalPages.b2b")}
                            </a>
                        )}
                    </p>
                    <a
                        className="underline"
                        href={
                            MAILVISTA_DOMAIN_URLS[
                                MailvistaUrls.POLITIQUECONFIDENTIALITE
                            ].url
                        }
                        rel="noreferrer"
                        target="_blank"
                    >
                        {t("legalPages.privacyPolicy")}
                    </a>
                </div>
                <div className="flex flex-col items-center gap-2">
                    <Button
                        className="w-fit"
                        onClick={() => {
                            // Closing the Settings dialog releases Radix's
                            // scroll lock, which otherwise blocks scrolling
                            // inside the Didomi preferences panel (a portal
                            // rendered outside the dialog's DOM subtree).
                            setSettingsDialogOpen(false);
                            (window as any).Didomi.preferences.show?.();
                        }}
                    >
                        {t("settings.legalPages.consents")}
                    </Button>
                    <p className="max-w-[350px] text-center font-normal">
                        <span className="font-bold">
                            {t("settings.legalPages.warning")}{" "}
                        </span>
                        {t("settings.legalPages.warningDescription")}
                    </p>
                </div>
            </div>

            <div />
        </div>
    );
};

export default LegalPagesSettings;
